// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileState__pointer-f1ec59 {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/main/components/FileState/FileState.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF","sourcesContent":[".pointer {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pointer": `FileState__pointer-f1ec59`
};
module.exports = ___CSS_LOADER_EXPORT___;
